// tiny localStorage cache for offline resilience
export const cacheGet = (key) => {
  try {
    const raw = localStorage.getItem(`rr_${key}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const cacheSet = (key, value) => {
  try {
    localStorage.setItem(`rr_${key}`, JSON.stringify(value));
  } catch {}
};
